import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SharePermission} from 'common/src/modules/sharing/sharing.types';
import {SmartCreative} from 'common/src/modules/smartCreative/smartCreative.types';
import {SmartCreativeBaseState} from './smartCreativeBase.types';
import smartCreativeTrackChangesReducer, {
  smartCreativeTrackChangesInitialState,
} from '../trackChanges/smartCreativeTrackChanges.slice';
import {Widget} from 'common/src/modules/dynamicParameters/widgets/widgets.types';

const smartCreativeBaseInitialState: SmartCreativeBaseState = {
  smartCreative: null,
  sharePermissions: [],
  tearsheetName: '',
  loading: true,
  trackChanges: smartCreativeTrackChangesInitialState,
  widgets: [],
};

const smartCreativeBaseSlice = createSlice({
  name: BreadcrumbName.SmartCreativePage,
  initialState: smartCreativeBaseInitialState as SmartCreativeBaseState,
  reducers: {
    resetState: () => smartCreativeBaseInitialState,
    setPageData: (
      state,
      action: PayloadAction<{smartCreative: SmartCreative; sharePermissions: SharePermission[]}>,
    ) => {
      state.smartCreative = action.payload.smartCreative;
      state.sharePermissions = action.payload.sharePermissions;
    },

    updateSmartCreative: (state, action: PayloadAction<Partial<SmartCreative>>) => {
      if (!state.smartCreative) return;
      state.smartCreative = {...state.smartCreative, ...action.payload};
    },

    updateTearsheetName: (state, action: PayloadAction<string>) => {
      state.tearsheetName = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setWidgets: (state, action: PayloadAction<Widget[]>) => {
      state.widgets = action.payload;
    },
  },
});

export const {
  resetState,
  setPageData,
  updateSmartCreative,
  updateTearsheetName,
  setLoading,
  setWidgets,
} = smartCreativeBaseSlice.actions;

export default function smartCreativeBaseReducer(
  state: SmartCreativeBaseState | undefined,
  action: PayloadAction,
): SmartCreativeBaseState {
  const baseState = smartCreativeBaseSlice.reducer(
    state ?? smartCreativeBaseInitialState,
    action,
  );

  const trackChangesState = smartCreativeTrackChangesReducer(baseState.trackChanges, action);

  return {
    ...baseState,
    trackChanges: trackChangesState,
  };
}
